import segment from 'src/js/modules/analytics/segment';

const {
  trackers: { trackEvent },
  constants: { events },
} = segment;

function onDialogCancel(dialogType) {
  trackEvent(events.DIALOG_CANCELLED, {
    dialogId: dialogType,
  });
}

export default onDialogCancel;
